// @view/panels/payment/choose-subscription/PromoCodeError.panel.tsx
import React from "react";
import EmptyView from "@view/EmptyView";
import type { PromoCodeErrorPhase } from "@ps-bridge/models/documents/promoCodeErrorPhase";
import PromoCodeErrorView from "@view/payment/choose-subscription/PromoCodeError.view";

type PromoCodeErrorPanelProps = {
  phase: PromoCodeErrorPhase;
  message: string;
};

const PromoCodeErrorPanel: React.FC<PromoCodeErrorPanelProps> = ({ phase, message }) => {
  const phaseKeys = {
    hidden: "hidden",
    visible: "visible",
  } as const satisfies Record<PromoCodeErrorPhase, PromoCodeErrorPhase>;

  const render = {
    [phaseKeys.hidden]: <EmptyView />,
    [phaseKeys.visible]: <PromoCodeErrorView promoCodeErrorMessage={message} />,
  } as const satisfies Record<PromoCodeErrorPhase, React.ReactElement>;

  return render[phase as keyof typeof render];
};

export default React.memo(PromoCodeErrorPanel, (prevProps, nextProps) => {
  return prevProps.phase === nextProps.phase;
});
